// extracted by css-extract-rspack-plugin
export default {"canceledText":"Row__canceledText--PmTAW"};